module.exports = __webpack_public_path__ + "img/caonima.1cb4f698.gif";